import { ValidateAny } from "./ValidateAny";
import { Message, getMessage } from "./helpers";
import { parseNumber } from "../../../global/formatting";

export class ValidateNumber<TRoot> extends ValidateAny<number, TRoot> {
    public parse(value: string) {
        if (typeof (value) === 'string')
            return value ? parseNumber(value) : null;

        return value;
    }
    public required(condition?: (root: TRoot) => boolean) {
        this.isRequired = true;

        this.add((value: any, root: TRoot) => {
            if (typeof(value) === 'number' && !isNaN(value)) {
                return null;
            }
            if (condition && !condition(root)) {
                return null;
            }
            return { message: `${this.name} is verplicht` };
        });
        return this;
    }

    public isNumber(message?: Message) {
        this.add((value: any) => {
            if (value === null || value === undefined || typeof(value) === 'undefined')
                return null;
            if (isNaN(value))
                return { message: getMessage(this.name, message, `De waarde voor ${this.name} is niet herkend als nummer.`) };
            return null;
        });
        return this;
    }
    public range(min: number, max?: number, message?: Message) {
        this.add((value: number) => {
            if (!value && value !== 0)
                return null;

            if (typeof (max) !== 'number' && value < min)
                return { message: getMessage(this.name, message, `${this.name} moet minimaal ${min} zijn.`) };
            if (typeof (min) !== 'number' && value > max)
                return { message: getMessage(this.name, message, `${this.name} mag maximaal ${max} zijn.`) };
            if (value < min || value > max)
                return { message: getMessage(this.name, message, `${this.name} moet tussen ${min} en ${max} zijn.`) };

            return null;
        });
        return this;
    }
}
